'use strict';

var namespace = 'customMaker/';

///////////
//
// ACTION TYPES
//
///////////
module.exports = {


	BACKBONE_MODEL_SET: namespace + 'BACKBONE_MODEL_SET',
	SET_MODEL_ID: namespace + 'SET_MODEL_ID',

	///////////
	// HOTSPOTS
	///////////
	ADD_HOTSPOT: namespace + 'ADD_HOTSPOT',
	UPDATE_HOTSPOT: namespace + 'UPDATE_HOTSPOT',
	REMOVE_HOTSPOT: namespace + 'REMOVE_HOTSPOT',
	SELECT_HOTSPOT: namespace + 'SELECT_HOTSPOT',

	CHANGE_BOX_MODE: namespace + 'CHANGE_BOX_MODE',
	///////////
	// INPUT MODE
	///////////
	CHANGE_PREVENT_INPUT: namespace + 'CHANGE_PREVENT_INPUT',
	TOGGLE_PREVENT_INPUT: namespace + 'TOGGLE_PREVENT_INPUT',

	///////////
	// MODEL INFO
	///////////
	CHANGE_MODEL_ID: namespace + 'CHANGE_MODEL_ID',
	CHANGE_MODEL_URL: namespace + 'CHANGE_MODEL_URL',
	CHANGE_MODEL_ROTATION: namespace + 'CHANGE_MODEL_ROTATION',
	CHANGE_RESOLUTION: namespace + 'CHANGE_RESOLUTION',

	///////////
	// VIEW 
	///////////
	SET_VIEW_MODE: namespace + 'SET_VIEW_MODE',
	TOGGLE_IS_PREVIEWING: namespace + 'TOGGLE_IS_PREVIEWING',
	SHOW_SHAPE_JS_VIEW: namespace + 'SHOW_SHAPE_JS_VIEW',
	SHOW_X3DOM_VIEW: namespace + 'SHOW_X3DOM_VIEW',

	WAIT_FOR_VIEWER: namespace + 'WAIT_FOR_VIEWER',
	STOP_WAITING_FOR_VIEWER: namespace + 'STOP_WAITING_FOR_VIEWER',	

	////////
	// FORM ACTIONS
	///////
	SET_FORM_ACTIONS: namespace + 'SET_FORM_ACTIONS'
};
